import { useSnackbar } from 'notistack';
import { KwConfirmationModal } from '../../kw-ui-components/KwConfirmationModal';
import { httpRequest } from '../../utils/network.service';
import { DeviceOwner } from './DeviceOwnersPopover';
import { getUnenrollDeviceOwnerExtraDetails } from './getUnenrollDeviceOwnerExtraDetails';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  deviceOwner: DeviceOwner;
  mutate: () => void;
}

export const DeviceOwnerUnenrollModal = ({ isOpen, onClose, deviceOwner, mutate }: IProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const unenrollDeviceOwner = async () => {
    const { data, error } = await httpRequest({
      path: `${process.env.ORGANIZATION_SERVICE_URL}/organizations/deviceowners/${deviceOwner.id}`,
      method: 'DELETE',
    });

    if (error) {
      enqueueSnackbar(`Error unenrolling device owner ${deviceOwner.email}`, {
        variant: 'error',
      });
      return;
    }

    if (!data?.deleted) {
      enqueueSnackbar(`Error unenrolling device owner ${deviceOwner.email}`, {
        variant: 'error',
      });
      mutate();
      return;
    }

    enqueueSnackbar(`Successfully unenrolled device owner ${deviceOwner.email}`, {
      variant: 'success',
    });
    mutate();
  };

  return (
    <KwConfirmationModal
      title="Unenroll Device Owner"
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={unenrollDeviceOwner}
      description={`unenroll ${deviceOwner.email} from the organization`}
      extraDetails={getUnenrollDeviceOwnerExtraDetails()}
    />
  );
};
